/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v13.3.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultColumnTypes = {
    "numericColumn": {
        "headerClass": "ag-numeric-header",
        "cellClass": "ag-numeric-cell"
    }
};



//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/ag-grid/dist/lib/entities/defaultColumnTypes.js
// module id = ../../../../ag-grid/dist/lib/entities/defaultColumnTypes.js
// module chunks = 3